<template>
  <div class="blockquote">
    <the-parallax :image="cover"></the-parallax>
    <div class="blockquote-content">
      <blockquote class="blockquote-container">
        <font-awesome-icon icon="quote-left"></font-awesome-icon>
        <p class="blockquote-quote">
          <slot></slot>
        </p>
        <p class="blockquote-author">Autor o Extracto</p>
      </blockquote>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import TheParallax from '@/components/TheParallax.vue';

export default {
  name: 'TheBlockquote',
  components: {
    FontAwesomeIcon,
    TheParallax,
  },
  props: {
    cover: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.blockquote {
  position: relative;

  .blockquote-content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .blockquote-container {
      padding: 60px 80px 40px;
      position: relative;
      color: #fff;

      svg {
        font-size: 8em;
        position: absolute;
        color: rgba(33, 33, 33, 0.75);
        z-index: -1;
      }

      .blockquote-quote {
        font-family: Georgia, "Times New Roman", Times, serif;
        font-weight: normal;
        font-size: 2.3em;
        line-height: 1.5em;
        text-align: center;
        z-index: 1;
      }

      &::after {
        content: "";
        top: 20px;
        left: 50%;
        margin-left: -100px;
        position: absolute;
        border-bottom: 3px solid #76665b;
        height: 3px;
        width: 200px;
      }
      .blockquote-author {
        font-family: Georgia, "Times New Roman", Times, serif;
        font-weight: normal;
        font-size: 1.8em;
        line-height: 1.5em;
        text-align: center;
        z-index: 1;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .blockquote-container {
    padding: 0px !important;

    svg {
      font-size: 4em;
    }

    .blockquote-quote {
      font-size: 1.8em;
    }

    .blockquote-author {
      font-size: 1.3em;
    }
  }
}
</style>
